module.exports = __webpack_public_path__ + "static/img/VIENNA_MAPLE.1b022ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/VIENNA_MAPLE.jpg
// module id = RIi5
// module chunks = 0